import RecapReportIntervals from './RecapReportIntervals';

export default RecapReportIntervals;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportIntervals/index.tsx